export default "__VITE_ASSET__706cd81f__"